import { Snackbar } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import FeaturedIcon from "./FeaturedIcon";
import { createPortal } from "react-dom";

const getIcon = (type) => {
  switch (type?.toLowerCase()) {
    case "warning":
      <svg
        width="12"
        height="11"
        viewBox="0 0 12 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.72401 3.55137V5.55137M5.72401 7.55137H5.72901M4.86901 0.981372L0.634009 8.05137C0.546693 8.20258 0.500493 8.37402 0.500004 8.54863C0.499515 8.72324 0.544755 8.89494 0.631223 9.04663C0.717691 9.19833 0.842372 9.32475 0.992863 9.4133C1.14335 9.50185 1.31441 9.54945 1.48901 9.55137H9.95901C10.1336 9.54945 10.3047 9.50185 10.4552 9.4133C10.6056 9.32475 10.7303 9.19833 10.8168 9.04663C10.9033 8.89494 10.9485 8.72324 10.948 8.54863C10.9475 8.37402 10.9013 8.20258 10.814 8.05137L6.57901 0.981372C6.48987 0.834425 6.36437 0.712932 6.21461 0.628614C6.06484 0.544296 5.89588 0.5 5.72401 0.5C5.55214 0.5 5.38317 0.544296 5.23341 0.628614C5.08365 0.712932 4.95814 0.834425 4.86901 0.981372Z"
          stroke="#DC6803"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>;

      break;
    case "error":
      <svg
        width="11"
        height="11"
        viewBox="0 0 11 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.5 3.5V5.5M5.5 7.5H5.505M10.5 5.5C10.5 8.26142 8.26142 10.5 5.5 10.5C2.73858 10.5 0.5 8.26142 0.5 5.5C0.5 2.73858 2.73858 0.5 5.5 0.5C8.26142 0.5 10.5 2.73858 10.5 5.5Z"
          stroke="#D92D20"
          strokelinecap="round"
          strokelinejoin="round"
        />
      </svg>;

      break;
    default:
      return (
        <svg
          width="11"
          height="11"
          viewBox="0 0 11 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.5 5.04286V5.50286C10.4994 6.58107 10.1503 7.6302 9.50467 8.49377C8.85908 9.35735 7.95164 9.9891 6.91768 10.2948C5.88372 10.6005 4.77863 10.5638 3.76724 10.1902C2.75584 9.8165 1.89233 9.12591 1.30548 8.2214C0.718633 7.31688 0.439896 6.24689 0.510838 5.17102C0.581781 4.09514 0.998603 3.07103 1.69914 2.2514C2.39968 1.43177 3.34639 0.860553 4.39809 0.622935C5.4498 0.385317 6.55013 0.49403 7.535 0.932862M10.5 1.50286L5.5 6.50786L4 5.00786"
            stroke="#039855"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
  }
};

const Toast = ({
  open = false,
  onClose,
  icon = null,
  type = "success",
  message,
  closeIcon = (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 5L5 15M5 5L15 15"
        stroke="#667085"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  ...props
}) => {
  // console.log("open in toast", open);

  if (!open) return null;
  return createPortal(
    <Snackbar
      className="toastContainer"
      open={open}
      onClose={onClose}
      {...props}
    >
      <div className="toastContentContainer">
        {icon ? (
          icon
        ) : (
          <FeaturedIcon
            size="md"
            color={type.toLowerCase()}
            theme="lightCircleOutline"
            icon={getIcon(type)}
          />
        )}
        {message && <p className="toastContent">{message}</p>}
        {closeIcon && <span onClick={onClose}>{closeIcon}</span>}
      </div>
    </Snackbar>,
    document.body
  );
};

export default Toast;

Toast.propTypes = {
  open: PropTypes.bool.isRequired,
  type: PropTypes.oneOf(["error", "warning", "success"]),
};
